import { FC } from 'react';
import { DashboardWidget, useDashboardWidget } from '@frontend/grid-dashboard';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { useTooltip } from '@frontend/design-system';
import { isWidgetWidthSmall } from '../../../utils/widgets';
import { ProgressSwitcher } from './progress-switcher';
import { infoIconContainer, dashboardHeader, progressSwitcherWrapper, dashboardHeaderContainer } from './styles';
import { TimeRangeSelector } from './time-range-selector';

export const WidgetHeader: FC = () => {
  const { t } = useTranslation('task-center');
  const { Tooltip, triggerProps, tooltipProps } = useTooltip({ placement: 'bottom' });
  const { currentBreakpoint, isEditMode } = useDashboardWidget();

  const isWidthSmall = isWidgetWidthSmall(currentBreakpoint);

  return (
    <DashboardWidget.Header css={[dashboardHeaderContainer, !isEditMode && dashboardHeader]}>
      <span {...triggerProps} css={infoIconContainer} tabIndex={0} aria-label={t('Assigned tasks will appear here.')}>
        <Icon name='info-small' />
      </span>
      <Tooltip {...tooltipProps}>{t('Assigned tasks will appear here.')}</Tooltip>
      <div css={progressSwitcherWrapper(isWidthSmall)}>
        <ProgressSwitcher />
      </div>
      <TimeRangeSelector isWidthSmall={isWidthSmall} />
    </DashboardWidget.Header>
  );
};
